import { useNavigate, useParams } from "react-router-dom";
import { useAgendamentoStepIndicator } from "../../../hooks/useAgendamentoStepIndicator";
import { useConsultarVeiculoPorPlaca } from "../../../hooks/queries/veiculo/useConsultarVeiculoPorPlaca/useConsultarVeiculoPorPlaca";
import { useContextSite } from "../../../context/Context";
import { Tracking } from "../../../services/Tracking";
import { IFormBuscarVeiculoPorPlacaValues } from "../../Molecules/FormBuscarVeiculoV2/useFormBuscarVeiculoV2";

export const useSurveyV2 = () => {
  const navigate = useNavigate();
  const { uuidAgendamento } = useParams();
  const stepIndicator = useAgendamentoStepIndicator();
  const { setIsLoad } = useContextSite();
  const { mutate: consultarVeiculo } = useConsultarVeiculoPorPlaca();

  function handleSubmit(data: IFormBuscarVeiculoPorPlacaValues) {
    setIsLoad(true);
    consultarVeiculo(
      {
        Placa: data.placa,
        Renavam: data.renavam,
        uuidAgendamento,
      },
      {
        onSuccess: ({ data: veiculo }) => {
          navigate(
            `/agendamento/${uuidAgendamento}/servicos/veiculo?uuidVeiculo=${veiculo.uuid}`,
          );
        },
        onError: ({
          response: {
            data: { mensagem },
          },
        }: any) => {
          Tracking.error("mapa:agendamento/servicos/vistoria:consultar-veiculo-falhou", {
            mensagem,
          });
        },
        onSettled: () => setIsLoad(false),
      },
    );
  }

  return { stepIndicator, handleSubmit };
};
